import { STATUS_ENTREGA_NORMALIZED } from '@/Constants';
import { StatusDelivery } from '@/Interfaces/Data';
import { colors } from '@/Themes/Colors';

interface HelperDeliveryStatus {
  key: StatusDelivery;
  text: string;
  color: string;
}

export const DELIVERY_STATUS_HELPER: Record<
  StatusDelivery,
  HelperDeliveryStatus
> = {
  ACEITO: {
    key: 'ACEITO',
    color: colors.successLight,
    text: STATUS_ENTREGA_NORMALIZED.ACEITO,
  },
  ASSOCIADO: {
    key: 'ASSOCIADO',
    color: colors.info20,
    text: STATUS_ENTREGA_NORMALIZED.ASSOCIADO,
  },
  CANCELADO: {
    key: 'CANCELADO',
    color: colors.danger20,
    text: STATUS_ENTREGA_NORMALIZED.CANCELADO,
  },
  CHEGOU_NA_LOJA: {
    key: 'CHEGOU_NA_LOJA',
    color: colors.gray20,
    text: STATUS_ENTREGA_NORMALIZED.CHEGOU_NA_LOJA,
  },
  CHEGOU_NO_CLIENTE: {
    key: 'CHEGOU_NO_CLIENTE',
    color: colors.gray20,
    text: STATUS_ENTREGA_NORMALIZED.CHEGOU_NO_CLIENTE,
  },
  PERSONALIZAR_CORRIDA: {
    key: 'PERSONALIZAR_CORRIDA',
    color: colors.gray20,
    text: STATUS_ENTREGA_NORMALIZED.PERSONALIZAR_CORRIDA,
  },
  ENTREGUE: {
    key: 'ENTREGUE',
    color: colors.brandGreen,
    text: STATUS_ENTREGA_NORMALIZED.ENTREGUE,
  },
  FINALIZADO: {
    key: 'FINALIZADO',
    color: colors.brandGreen,
    text: STATUS_ENTREGA_NORMALIZED.FINALIZADO,
  },
  PENDENTE: {
    key: 'PENDENTE',
    color: colors.gold,
    text: STATUS_ENTREGA_NORMALIZED.PENDENTE,
  },
  SAIU_DA_LOJA: {
    key: 'SAIU_DA_LOJA',
    color: colors.gray20,
    text: STATUS_ENTREGA_NORMALIZED.SAIU_DA_LOJA,
  },
};
